import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';

import {
	Nav4Communications as Nav4CommunicationsWithoutErrorBoundary,
	type Nav4CommunicationsProps,
} from './ui/index.tsx';

import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export const Nav4Communications = (props: Nav4CommunicationsProps) => {
	return (
		<UFOSegment name="nav4-sidebar-communications">
			<JSErrorBoundary
				fallback="flag"
				id="communications-section"
				packageName={PACKAGE_NAME}
				teamName={TEAM_NAME}
			>
				<Nav4CommunicationsWithoutErrorBoundary {...props} />
			</JSErrorBoundary>
		</UFOSegment>
	);
};
